import React, { useState, useEffect } from 'react';

const Filters = ({ filters, handleCheckEvent, selectedFilter }) => {
  const [isOpenGroupIndex, setOpenGroupIndex] = useState(0);

  useEffect(() => {
    const selectedFilterIndex = filters.findIndex(filter => filter.node.some(item => item.id === selectedFilter))
    setOpenGroupIndex(selectedFilterIndex)
  }, [selectedFilter])

  const accordionHandler = (index) => {
    setOpenGroupIndex(index)
  }

  return <div className="facet">
    <div className='facet-filters'>
      {filters.map((e, index) => (
        <div key={e.title}>
          {index > 0 ?
            <h4
              onClick={() => accordionHandler(index)}
              className={index === isOpenGroupIndex ? 'group-title opened' : 'group-title'}>
              {e.title}
            </h4>
            :
            <h4 className="default">{e.title}</h4>}
          <div className={index === 0 ? 'inputs-first' : index === isOpenGroupIndex ? 'inputs opened' : 'inputs'}>
            {index === isOpenGroupIndex || index === 0 ?
              e.node.map(el => (
                <div key={el.id} className="input-wrapper">
                  <input
                    id={el.id}
                    type="radio"
                    value={el.name}
                    name="facet-input"
                    checked={el.id === selectedFilter}
                    onChange={() => handleCheckEvent({ id: el.id, name: el.name })}
                  />
                  <label htmlFor={el.id}>{el.name}</label>
                </div>
              )) : <></>}
          </div>
        </div>
      ))}
    </div>
  </div>
}

export default Filters;
